import { memo, ReactNode, RefAttributes } from 'react';
import { Checkbox as RACCheckbox, CheckboxProps as RACCheckboxProps, CheckboxRenderProps } from 'react-aria-components';

import { merge } from '@/components';
import { CheckmarkIcon } from '@/components/icons';

export type CheckboxProps = RACCheckboxProps & RefAttributes<HTMLLabelElement>;

const ICheckbox = ({ className, children, ...rest }: CheckboxProps) => {
  return (
    <RACCheckbox className={merge('group/checkbox flex cursor-pointer gap-2', className)} {...rest}>
      {(props: CheckboxRenderProps & { defaultChildren: ReactNode | undefined }) => {
        let renderedChildren: ReactNode;
        if (typeof children === 'function') {
          renderedChildren = children(props);
        } else {
          renderedChildren = children;
        }

        return (
          <>
            <div className="group-data-[selected]/checkbox:bg-primary-600 flex size-4 items-center justify-center rounded-sm border border-gray-200 p-[0.125rem]">
              {props.isSelected ? <CheckmarkIcon className="group-data-[selected]/checkbox:text-white" /> : null}
            </div>
            {renderedChildren}
          </>
        );
      }}
    </RACCheckbox>
  );
};

export const Checkbox = memo(ICheckbox) as typeof ICheckbox;
